import {Button} from '@/components/ui/button/Button'
import {ComboboxInput} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {SelectComboboxList} from '@/components/ui/select-atoms/SelectAtoms'
import {makeSelectPopoverBaseStyle} from '@/components/ui/select-atoms/style'
import {Popover} from '@ariakit/react'
import styled, {css} from 'styled-components'

export const StyledUsersAndGroupsMultiSelectOverlay = styled.div(
    ({theme: {zIndex}}) => css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: transparent;
        z-index: ${zIndex.dropdown + 1};
        pointer-events: auto;
    `
)

export const StyledUsersAndGroupsMultiSelectPopover = styled(Popover)(
    ({theme, theme: {zIndex}}) => css`
        ${makeSelectPopoverBaseStyle(theme)};
        width: 280px;
        z-index: ${zIndex.dropdown + 2};
    `
)

export const StyledUsersAndGroupsMultiSelectPopoverInput = styled(ComboboxInput)(
    ({theme: {spacing}}) => css`
        margin: ${spacing}px 0;
    `
)

export const StyledUsersAndGroupsMultiSelectComboboxList = styled(SelectComboboxList)(
    ({theme: {spacing}}) => css`
        margin-top: ${spacing}px;
    `
)

export const StyledUsersAndGroupsMultiSelectPopoverOption = styled(Button)(
    ({theme: {spacing, palette}}) => css`
        width: 100%;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 6px;
        justify-content: flex-start;
        align-items: flex-start;
        &:hover {
            background-color: ${palette.neutral[100]};
        }
    `
)

export const StyledUsersAndGroupsSelectGroupLabel = styled.div(
    ({theme: {palette, spacing, typography, opacities}}) => css`
        ${typography.textXs};
        color: ${palette.neutral['500']};
        padding: ${spacing * 2}px;
        font-weight: 500;
        position: sticky;
        top: 0;
        background: ${palette.neutral['50']}${opacities['90']};
        backdrop-filter: blur(2px);
        text-transform: uppercase;
        letter-spacing: 0.025em;
    `
)
